import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import ThemeApplicator from "@/components/ThemeApplicator";
import TrackingInjector from "@/components/TrackingInjector";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import VehiclePage from "@/pages/VehiclePage";
import Admin from "@/pages/Admin";
import Catalog from "@/pages/Catalog";
import Apply from "@/pages/Apply";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import SEOLanding from "@/pages/SEOLanding";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function App() {
  return (
    <div className="App bg-[#0A0B0E] min-h-screen text-gray-100">
      <BrowserRouter>
        <ThemeApplicator />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/category/:id" element={<CategoryPage />} />
          <Route path="/car/:id" element={<CategoryPage />} />
          <Route path="/vehicle/:id" element={<VehiclePage />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/manqanis-gakiraveba-taxisistvis" element={<SEOLanding pageKey="manqanis-gakiraveba-taxisistvis" />} />
          <Route path="/prius-gakiraveba" element={<SEOLanding pageKey="prius-gakiraveba" />} />
          <Route path="/tesla-gakiraveba" element={<SEOLanding pageKey="tesla-gakiraveba" />} />
          <Route path="/elektro-manqanebi-taxisistvis" element={<SEOLanding pageKey="elektro-manqanebi-taxisistvis" />} />
          <Route path="/tavisufali-manqanebi" element={<SEOLanding pageKey="tavisufali-manqanebi" />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <FloatingWhatsApp />
        <TrackingInjector />
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
